export type LoginOptions = {
  fromReceiptsMicrosite?: boolean;
};

export const defaultLoginOptions = {
  fromReceiptsMicrosite: false,
};

export type LoginB2cParams = {
  userJourneyMode?:
    | 'LOCAL_ACCOUNT_REGISTRATION' /* LOCAL_ACCOUNT_REGISTRATION = straight to create account*/
    | 'EXTERNAL_ACCOUNT' /* EXTERNAL_ACCOUNT + domainHint = skip login page, straight to social login with google or facebook */;
  domainHint?: 'google.com' | 'facebook.com' | string;
  loginHint?: string /* Email to prefill on login page. */;
} & Record<string, string>;
